import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { number } from '@storybook/addon-knobs';
import { MatCheckbox } from '@angular/material/checkbox';
import {MatSort, Sort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { KeyValueI, KeyValue } from '../../models/common';
import { ProductsListMapperI } from '../../models/products-list/products-list';
import * as moment from 'moment';


@Component({
  selector: 'anterasoftware-kanban-products-list',
  templateUrl: './kanban-products-list.component.html',
  styleUrls: ['./kanban-products-list.component.scss']
})
export class KanbanProductsListComponent implements OnInit {

  @ViewChild(MatSort) public sort: MatSort = {} as MatSort;

  @Input() public listDataSource: any[] = [];
  @Input() public displayedColumns: string[] = [];
  @Input() public pageSizeOptions: number[] = [];
  @Input() public tableLength: number = 0;
  @Input() public page: string = '';
  @Input() public displayActionsBar: boolean = false;
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  @Input() public mappingFields: any[] = [];

  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onFavoriteToggle: EventEmitter<any> = new EventEmitter();
  @Output() public onColumnClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPaginateFire: EventEmitter<any> = new EventEmitter();
  @Output() public onSortFired: EventEmitter<any> = new EventEmitter();

  public totalColumnDropdownList: KeyValueI[] = [];
  public dataSource: any;
  public selectAll: boolean = false;
  public pageSize: number = 50;
  // @Input() public ds: any;
  // @Input() public columns: any;
  constructor() { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.listDataSource);
    // this.dataSource = new MatTableDataSource(this.ds);
    // this.displayedColumns = this.columns;
  }

  public ngOnChanges() {
    this.dataSource = new MatTableDataSource(this.listDataSource);
  }

  public paginate(event: any) {
    const paginateObj = {
      offset: event.pageIndex,
      limit: event.pageSize,
    };

    this.pageSize = event.pageSize;
    this.onPaginateFire.emit(paginateObj);
  }


  public onColumnClicked(element: ProductsListMapperI, columnName: string): void {
    this.onColumnClick.emit({ columnName, rowSelected: element });
  }

  public toggleAll(selectType: string, checkbox?: MatCheckbox, selectedRow?: ProductsListMapperI ): void {

    switch (selectType){
      case 'SINGLE':
        this.dataSource.data.find((row: ProductsListMapperI) => row.id === selectedRow?.id).select = checkbox?.checked;
        break;
      case 'FIRST_50':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.dataSource.data.forEach((data: ProductsListMapperI) => (data.select = true));
        break;
      case 'SELECT_ALL':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.dataSource.data.forEach((data: ProductsListMapperI) => (data.select = true));
        break;
      case 'DESELECT_ALL':
        this.selectAll = false;
        this.dataSource.data.forEach((data: ProductsListMapperI) => (data.select = false));
        break;
      case 'SELECT_ALL_TOGGLE':
        this.selectAll = !this.selectAll;
        this.dataSource.data.forEach((data: ProductsListMapperI) => (data.select = this.selectAll));
        selectType = this.selectAll ? 'SELECT_ALL' : 'DESELECT_ALL';
        break;
      default:
        this.selectAll = !this.selectAll;
        this.dataSource.data.forEach((data: ProductsListMapperI) => (data.select = this.selectAll));
        break;
    }

    this.selectClicked.emit({data: this.dataSource.data, selectType});
  }

  public onListViewSort(event: Sort) {
    this.onSortFired.emit(event);
  }
  
  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }

  processImageFromImaginary(imageUrl: any){
    let imageFromImaginary = imageUrl;
    if(imageFromImaginary && imageFromImaginary.indexOf('cdnl.sanmar.com') > 0){
        const operations = encodeURI(JSON.stringify([
            {
                'operation': 'thumbnail',
                'params': {
                    'width': 175,
                    'background': '255,255,255',
                    'type': 'jpeg',
                    'quality': 100,

                }
            },
            {
                'operation': 'convert',
                'params': {
                    'type': 'jpeg',
                    'quality': 100,
                }
            }
        ]));
        imageFromImaginary = `https://h4x0rt3hp74n37L4vv7.anterasaas.com/api/v1/imaginary/pipeline?url=${encodeURIComponent(imageFromImaginary)}&operations=${operations}`;
    }
    return imageFromImaginary;
  }
}
